<template>
<CheckboxSelector :label="t('Subgroups')" v-model="subgroupsIds" :options="options" :tabindex="tabindex" :disabled="disabled"/>
</template>

<script>
import CheckboxSelector from './../selectors/CheckboxSelector.vue';
import i18n from '../../i18n';

export default {
    name: 'SubgroupsFilter',

    components: {
        CheckboxSelector
    },

    computed: {
        subgroupsIds: {
            get () {
                return this.$store.state.subgroupsIds;
            },
            set (subgroupsIds) {
                this.$store.commit('setSubgroupsIds', { subgroupsIds });
            }
        },

        options () {
            return this.$store.state.subgroups.map(subgroup => ({
                text: subgroup.Name,
                value: subgroup.Id
            }));
        },

        disabled () {
            return this.$store.getters.areSubgroupsLoading ||
                this.options.filter(option => !option.disabled).length === 0;
        },

        tabindex () {
            return this.disabled ? null : 3;
        }
    },

    methods: {
        t (str) {
            return i18n(str, this.$store.state.lang);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/filters/SubgroupsFilter.vue